import { useMutation } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';

export const useSystemMaintenance = () => {
  const { toast } = useToast();

  const cleanupActivityLogs = useMutation({
    mutationFn: async () => {
      console.log('Iniciando limpeza de logs de atividade...');
      
      const { data, error } = await supabase.rpc('cleanup_activity_logs');
      
      if (error) {
        console.error('Erro na limpeza de logs:', error);
        throw error;
      }
      
      console.log(`Limpeza concluída: ${data} registros removidos`);
      return data as number;
    },
    onSuccess: (deletedCount) => {
      if (deletedCount > 0) {
        toast({
          title: "Limpeza concluída",
          description: `${deletedCount} registros de atividade foram removidos.`,
        });
      } else {
        toast({
          title: "Limpeza executada",
          description: "Nenhum registro antigo encontrado para remoção.",
        });
      }
    },
    onError: (error: any) => {
      console.error('Erro na limpeza:', error);
      toast({
        title: "Erro na limpeza",
        description: "Não foi possível executar a limpeza dos logs.",
        variant: "destructive",
      });
    },
  });

  // Auto-cleanup: executa 1x por dia se não foi executado hoje
  const autoCleanup = () => {
    const lastCleanup = localStorage.getItem('lastActivityLogCleanup');
    const today = new Date().toDateString();
    
    if (lastCleanup !== today) {
      console.log('Executando limpeza automática de logs...');
      cleanupActivityLogs.mutate();
      localStorage.setItem('lastActivityLogCleanup', today);
    }
  };

  return {
    cleanupActivityLogs,
    autoCleanup,
  };
};